import { render } from "./TopBarLatitudini.vue?vue&type=template&id=18a01ece&scoped=true"
import script from "./TopBarLatitudini.vue?vue&type=script&lang=js"
export * from "./TopBarLatitudini.vue?vue&type=script&lang=js"

import "./TopBarLatitudini.vue?vue&type=style&index=0&id=18a01ece&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a01ece"]])

export default __exports__